import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, createInvalidVendorSection} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productVendors,
    sections: [
        createInvalidPartSection(),
        createInvalidVendorSection(),
    ],
};
